import invariant from 'invariant'
import { isFSA } from 'flux-standard-action'
import {
  INGREDIENT_RECIPES_SET_RECIPES_DETAIL,
  INGREDIENT_RECIPES_SET_RECIPES,
  INGREDIENT_RECIPES_SET_OUTLETS,
  INGREDIENT_RECIPES_SET_CURRENT_PAGE,
  INGREDIENT_RECIPES_SET_TOTAL_PAGE,
  INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD,
  INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN,
  INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN,
  INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL,
  INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL,
  INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING,
  INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING,
  INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL,
  INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL,
  INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_SHOW_IMPORT_MODAL,
  INGREDIENT_RECIPES_HIDE_IMPORT_MODAL,
  INGREDIENT_RECIPES_UNSET_FILTER_STATE,
  INGREDIENT_RECIPES_SET_FILTER_STATE,
  INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN,
  INGREDIENT_RECIPES_SET_ITEM_VARIANT,
  INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT,
  INGREDIENT_RECIPES_SHOW_DELETE_MODAL,
  INGREDIENT_RECIPES_HIDE_DELETE_MODAL,
  INGREDIENT_RECIPES_SET_RECIPES_FORM,
  INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_RECIPES_SET_CREATED_OUTLETS,
  INGREDIENT_RECIPES_IS_SUBMITTING_FORM
} from 'actions/ingredients/recipes/constants'
let initialState = {
  outlets: [],
  recipes: [],
  ingredientRecipes: [],
  openRightColumn: false,
  recipesDetail: null,
  ingredientAdjustmentDetail: null,
  currentPage: null,
  totalPage: null,
  showAddItemsModal: false,
  addIngredients: {
    ingredients: [],
    ingredient: [],
    isLoading: false,
    selectedId: null,
    alreadyAddedAlert: false,
    ingredientQuantity: null,
    keyword: null
  },
  showConfirmSubmitModal: false,
  filterState: {keyword: ''},
  itemsDropdowns: [],
  itemVariant: [],
  showDeleteModal: false,
  recipesForm: {
    recipe_ingredients: [],
    item_id: null,
    item_name: null,
    item_variant_id: null,
    item_variant_name: null,
    sku: null
  },
  showSaveToAllOutletsModal: false,
  createdOutlets: null,
  isSubmittingForm: false
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )

  let {type, payload} = action

  switch (type) {
    case INGREDIENT_RECIPES_OPEN_RIGHT_COLUMN:
      return {...state, openRightColumn: true}
    case INGREDIENT_RECIPES_CLOSE_RIGHT_COLUMN:
      return {...state, openRightColumn: false}
    case INGREDIENT_RECIPES_SET_RECIPES:
      return {...state, recipes: payload.recipes}
    case INGREDIENT_RECIPES_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case INGREDIENT_RECIPES_SET_RECIPES_DETAIL:
      return {...state, recipesDetail: payload.recipes}
    case INGREDIENT_RECIPES_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.page}
    case INGREDIENT_RECIPES_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.page}
    case INGREDIENT_RECIPES_SHOW_ADD_ITEMS_MODAL:
      return {...state, showAddItemsModal: true}
    case INGREDIENT_RECIPES_HIDE_ADD_ITEMS_MODAL:
      return {...state, showAddItemsModal: false}
    case INGREDIENT_RECIPES_ADD_ITEMS_SET_ITEMS:
      return {...state, addIngredients: {...state.addIngredients, ingredients: payload.ingredients}}
    case INGREDIENT_RECIPES_ADD_ITEMS_SET_INGREDIENTS:
      return {...state, addIngredients: {...state.addIngredients, ingredients: payload.ingredients}}
    case INGREDIENT_RECIPES_ADD_ITEMS_SHOW_LOADING:
      return {...state, addIngredients: {...state.addIngredients, isLoading: true}}
    case INGREDIENT_RECIPES_ADD_ITEMS_HIDE_LOADING:
      return {...state, addIngredients: {...state.addIngredients, isLoading: false}}
    case INGREDIENT_RECIPES_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT:
      return {...state, addIngredients: {...state.addIngredients, alreadyAddedAlert: true}}
    case INGREDIENT_RECIPES_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT:
      return {...state, addIngredients: {...state.addIngredients, alreadyAddedAlert: false}}
    case INGREDIENT_RECIPES_SHOW_CONFIRM_SUBMIT_MODAL:
      return {...state, showConfirmSubmitModal: true}
    case INGREDIENT_RECIPES_HIDE_CONFIRM_SUBMIT_MODAL:
      return {...state, showConfirmSubmitModal: false}
    case INGREDIENT_RECIPES_SHOW_IMPORT_MODAL:
      return {...state, showImportModal: true}
    case INGREDIENT_RECIPES_HIDE_IMPORT_MODAL:
      return {...state, showImportModal: false}
    case INGREDIENT_RECIPES_UNSET_FILTER_STATE:
      return {...state, filterState: {keyword: ''}}
    case INGREDIENT_RECIPES_SET_FILTER_STATE:
      return {...state, filterState: {keyword: payload.keyword}}
    case INGREDIENT_RECIPES_SET_ITEMS_DROPDOWN:
      return {...state, itemsDropdowns: payload.itemsDropdowns}
    case INGREDIENT_RECIPES_SET_ITEM_VARIANT:
      return {...state, itemVariant: payload.itemVariant}
    case INGREDIENT_RECIPES_ADD_RECIPES_SET_KEYWORD:
      return {...state, addIngredients: {...state.addIngredients, keyword: payload.keyword}}
    case INGREDIENT_RECIPES_ADD_INGREDIENT_SET_INGREDIENT:
      let ingredient = payload.ingredient
      return {...state, addIngredients: {...state.addIngredients, ingredient: ingredient, selectedId: ingredient ? ingredient.id : null, ingredientQuantity: payload.ingredientQuantity}}
    case INGREDIENT_RECIPES_SHOW_DELETE_MODAL:
      return {...state, showDeleteModal: true}
    case INGREDIENT_RECIPES_HIDE_DELETE_MODAL:
      return {...state, showDeleteModal: false}
    case INGREDIENT_RECIPES_SET_RECIPES_FORM:
      return {...state, recipesForm: payload.recipesForm}
    case INGREDIENT_RECIPES_SHOW_SAVE_TO_ALL_OUTLETS_MODAL:
      return {...state, showSaveToAllOutletsModal: true}
    case INGREDIENT_RECIPES_HIDE_SAVE_TO_ALL_OUTLETS_MODAL:
      return {...state, showSaveToAllOutletsModal: false}
    case INGREDIENT_RECIPES_SET_CREATED_OUTLETS:
      return {...state, createdOutlets: payload.createdOutlets}
    case INGREDIENT_RECIPES_IS_SUBMITTING_FORM:
      return {...state, isSubmittingForm: payload.isSubmittingForm}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/ingredients/recipes.js